var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['widget.form'] = (function () {
    'use strict';

    // <input> can't render the ::before pseudo-element that .btn-primary uses for its hover border,
    // so swap any submit input for an equivalent <button>.
    const normalizeSubmitButton = (form) => {
        const submitControl = form.querySelector('input[type="submit"].btn, button[type="submit"].btn');
        if (!submitControl) {
            return null;
        }

        let submitButton = submitControl;

        if (submitControl.tagName === 'INPUT') {
            const button = document.createElement('button');
            button.type = 'submit';
            button.className = submitControl.className;

            // Preserve non-value attributes (id, name, data-*, etc.) from the original submit input.
            Array.from(submitControl.attributes).forEach((attribute) => {
                if (attribute.name !== 'type' && attribute.name !== 'value' && attribute.name !== 'class') {
                    button.setAttribute(attribute.name, attribute.value);
                }
            });

            button.textContent = submitControl.value || 'Submit';
            submitControl.replaceWith(button);
            submitButton = button;
        }

        return submitButton;
    };

    const decorateContactSubmitButton = (submitButton) => {
        if (!submitButton) {
            return;
        }

        if (!submitButton.querySelector('.fa-circle-arrow-right')) {
            const icon = document.createElement('i');
            icon.className = 'fa-solid fa-circle-arrow-right ms-1';
            icon.setAttribute('aria-hidden', 'true');
            submitButton.appendChild(icon);
        }
    };

    // Required fields are marked with a CSS asterisk; explain it once, before the first field (WCAG 3.3.2)
    const addRequiredNote = (form) => {
        if (form.querySelector('.widget-form__required-note') || !form.querySelector('.widget-form__field.required')) {
            return;
        }

        const note = document.createElement('p');
        note.className = 'widget-form__required-note';
        note.textContent = 'Fields marked with an asterisk (*) are required.';
        form.prepend(note);
    };

    // Kentico's AJAX submit replaces the form markup with either the confirmation message or the form again (server-side
    // errors). The focused submit button disappears with it, so move focus to the confirmation, or re-initialize the new
    // form and focus its first error (WCAG 2.4.3, 3.3.1, 4.1.3).
    const watchFormReplacement = (widget, formContainer) => {
        if (!formContainer || !('MutationObserver' in window)) {
            return;
        }

        let currentForm = formContainer.querySelector('form');

        const observer = new MutationObserver(() => {
            if (currentForm && currentForm.isConnected) {
                return;
            }

            const newForm = formContainer.querySelector('form');
            currentForm = newForm;

            if (newForm) {
                initializeForm(widget, newForm);

                const firstServerError = Array.from(newForm.querySelectorAll('.field-validation-error'))
                    .find(el => el.textContent.trim() !== '');
                const errorField = firstServerError?.closest('.widget-form__field');
                errorField?.querySelector('input, select, textarea')?.focus();
                return;
            }

            const message = formContainer.querySelector('.formwidget-submit-text') || formContainer.firstElementChild;
            if (!message) {
                return;
            }

            const activeElement = document.activeElement;
            if (!activeElement || activeElement === document.body || !activeElement.isConnected) {
                message.setAttribute('tabindex', '-1');
                message.focus({ preventScroll: true });
            }
            else {
                const status = widget.querySelector('.widget-form__status');
                if (status) {
                    status.textContent = message.textContent.trim();
                }
            }
        });

        observer.observe(formContainer, { childList: true, subtree: true });
    };

    const initializeForm = (widget, form) => {
        const isContactForm = widget.id && widget.id.toLowerCase() === 'contact-form';

        const submitButton = normalizeSubmitButton(form);

        if (isContactForm) {
            decorateContactSubmitButton(submitButton);
        }

        // update the file uploader button (should there be any) for conformance
        const uploaderButton = form.querySelector(".ktc-uploader-text-button");
        if (uploaderButton) {
            uploaderButton.setAttribute("href", "#");
            uploaderButton.addEventListener("click", function (e) { e.preventDefault(); });
        }

        // if the form has been modified for custom validation, send it that way
        if (form.hasAttribute("data-zag-validate-form")) {
            App.Initialization['component.formValidation'].initialize(form);
        }

        addRequiredNote(form);
    };

    const initialize = (widget) => {
        const formContainer = widget.querySelector(".widget-form__form");
        const form = widget.querySelector("form");

        if (form) {
            initializeForm(widget, form);
        }

        watchFormReplacement(widget, formContainer);
    }

    return {
        initialize
    };

})();